import { render, staticRenderFns } from "./partnerBranchWise.vue?vue&type=template&id=05429c06&scoped=true"
import script from "./partnerBranchWise.vue?vue&type=script&lang=js"
export * from "./partnerBranchWise.vue?vue&type=script&lang=js"
import style0 from "./partnerBranchWise.vue?vue&type=style&index=0&id=05429c06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05429c06",
  null
  
)

export default component.exports